import React from 'react';

import { Anchor } from 'components/Error/ErrorDisplay/ErrorDisplay';
import {
  TextBlockWrapper,
  BlockWrapper,
  Message,
  BlockTitle,
} from '../../FAQActivityTracker.styles';
import { ReactComponent as CaretLeft } from 'icons/icon-caret-left.svg';
import { useHistory } from 'react-router';
import { BackLink } from './TextBlock.style';

const textBlocks = [
  {
    title: 'What is a Popular Playlist?',
    body: (
      <Message>
        Popular Playlists have high follower count, high stream count and/or
        high business value.
        <br />
        <br />
        They are curated by business stakeholders.
      </Message>
    ),
  },
  {
    title: 'What’s next?',
    body: (
      <Message>
        Currently, we are tracking a small amount of playlists in order to serve
        you information from our DSP partners as quickly as possible.
        <br />
        <br />
        Ultimately, we want to bring our Opus users real-time data. This is a
        step toward this goal.
      </Message>
    ),
  },
  {
    title: 'How do I get a playlist added to Popular Playlists?',
    body: (
      <Message>
        If you would like us to add a specific playlist, please send us an email
        at <Anchor href="mailto:opus-support@wmg.com">opus-support</Anchor> with
        a business case.
      </Message>
    ),
  },
];

const TextBlock: React.FC = () => {
  const history = useHistory();
  const goToPreviousPath = (): void => {
    history.goBack();
  };
  return (
    <TextBlockWrapper>
      <BackLink onClick={goToPreviousPath}>
        <CaretLeft /> <span className="backlink-label">Back</span>
      </BackLink>
      {textBlocks.map((block: any) => (
        <BlockWrapper key={block.title}>
          <BlockTitle>{block.title}</BlockTitle>
          {block.body}
        </BlockWrapper>
      ))}
    </TextBlockWrapper>
  );
};

export default TextBlock;
